<template lang="pug">
.message-register-detail
  // targets
  .mb-0
    span.key-name 宛先
  #targets.mb-3
    .mb-0
      span {{ value.receivers }}
  // shared messages
  .mb-0
    span.key-name 宛先全員とメッセージを共有する
  #is-shared-messages.mb-3
    .mb-0
      span(v-if="value.isSharedMessages == true") 宛先全員と共有する
      span(v-if="value.isSharedMessages == false") 共有しない
  // title
  .mb-0
    span.key-name タイトル
  #title.mb-3
    .mb-0
      span {{ value.title }}
  // text
  .mb-0
    span.key-name 本文
  #text.mb-3
    .mb-0
      span {{ value.text }}

  // line options
  .mt-2.mb-0
    span.key-name オプション設定
  // read button
  #add-read-button.mb-1
    .mb-0
      span.mr-2 見ましたボタン：
      span(v-if="value.addReadButton == true") つける
      span(v-if="value.addReadButton == false") つけない
  // option text
  #add-option-text.mb-1
    .mb-0
      span.mr-2 既読確認メッセージ：
      span(v-if="value.addOptionText == true") つける
      span(v-if="value.addOptionText == false") つけない
  // reply button
  #add-reply-button.mb-3
    .mb-0
      span.mr-2 返信ボタン：
      span(v-if="value.addReplyButton == true") つける
      span(v-if="value.addReplyButton == false") つけない

  // file input
  template(v-if="showTempFile")
    .mt-2.mb-0
      span.key-name 添付ファイル
    #files
      .mb-2(v-show="value.files && value.files.length <= 0")
        span ファイル無し
      .mb-2(v-for="file in value.files")
        .image(v-if="file.type == 'image/jpeg'")
          b-img.preview-image(thumbnail fluid :src="createFileUrl(file)" :alt="file.name")
        .video(v-if="file.type == 'video/quicktime' || file.type == 'video/mp4'")
          b-embed.preview-video(type="video" :src="createFileUrl(file)" controls)
        .pdf(v-if="file.type == 'application/pdf'")
          a.pdf-download(:href="createFileUrl(file)" download="HitomeQコネクト-メッセージ送信-添付ファイル.pdf" target="_blank") PDFファイルを開く
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * ### 新規送信メッセージ内容コンポーネント
 */
@Component({})
export default class MessageRegisterDetail extends Vue {
  @Prop({ required: true })
  value!: MessageRegisterDetailModel;

  @Prop({
    default: () => {
      return true;
    }
  })
  showTempFile!: boolean;

  /**
   * ### ファイルからオブジェクトURLを作成する
   */
  public createFileUrl(file: File): string {
    const url: string = window.URL.createObjectURL(file);
    return url;
  }
}

export interface MessageRegisterDetailModel {
  /** 宛先 */
  receivers: string;
  /** メッセージを共有するか否か */
  isSharedMessages: boolean;
  /** タイトル */
  title: string;
  /** 本文 */
  text: string;
  /** 見ましたボタンをつけるか */
  addReadButton: boolean;
  /** 既読確認メッセージをつけるか */
  addOptionText: boolean;
  /** 返信ボタンをつけるか */
  addReplyButton: boolean;
  /** 添付ファイル */
  files: Array<File>;
}
</script>
<style lang="scss" scoped>
.preview-pdf {
  height: 320px;
}
</style>
